import React from "react";

import "./button.css";

/**
 * @param {String} title: the title of the button
 * @returns
 */
const Button = ({ title, icon, rightIcon, size, type, disabled }) => {
  return (
    <button
      className={`button button--${type} button--${size}`}
      disabled={disabled}
    >
      <span className="left--icon">
        {icon && <img src={icon} alt="" />}
        {title}
      </span>
      {rightIcon && (
        <span className="right--icon">
          <img src={rightIcon} alt="" />
        </span>
      )}
    </button>
  );
};

export default Button;
